import { Bookmark } from '@/components/icons';
import { cn } from '@/lib/utils';
import { useAuth } from '../../lib/auth';
import { signInWithKakao } from '../../lib/supabase';
import { useSnackbar } from '@/components/ui/magic-snackbar';
import { useToggleBookmark } from './use-bookmark';

/**
 * 상세 우측 카드 우상단(16px, 16px)의 북마크 토글. 켜지면 검정 책갈피, 꺼지면 연회색.
 * 익명이 누르면 카카오 로그인으로 보낸다 — 로그인 뒤 돌아오면 다시 누르면 된다.
 */
export function BookmarkToggle({ grantId, isBookmarked }: { grantId: string; isBookmarked: boolean }) {
  const { isAuthenticated } = useAuth();
  const toggle = useToggleBookmark(grantId);
  const { showSnackbar } = useSnackbar();
  const on = isAuthenticated && isBookmarked;

  return (
    <button
      type="button"
      aria-pressed={on}
      aria-label={on ? '관심 공고에서 빼기' : '관심 공고에 담기'}
      title={on ? '관심 공고에서 빼기' : '관심 공고에 담기'}
      disabled={toggle.isPending}
      onClick={() => {
        if (!isAuthenticated) {
          void signInWithKakao();
          return;
        }
        const next = !isBookmarked;
        toggle.mutate(next, {
          onSuccess: () =>
            next
              ? showSnackbar('관심 공고에 추가합니다.', { type: 'success', action: { label: '마이페이지 이동', href: '/mypage' } })
              : showSnackbar('관심 공고에서 제외합니다.', { type: 'success' }),
          onError: () => showSnackbar('저장하지 못했어요. 잠시 후 다시 시도해 주세요.', { type: 'warning' }),
        });
      }}
      className={cn(
        'absolute right-4 top-4 flex size-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100',
        // 켜짐 = 사이트 초록(#18BB69). 꺼짐 = 연회색.
        on ? 'text-[#18BB69]' : 'text-gray-300 hover:text-gray-500',
      )}
    >
      <Bookmark className="size-8" />
    </button>
  );
}
